/**
 * Navigation Difficulty Section Component
 *
 * Single Responsibility: Orchestrates the navigation difficulty section layout
 * Follows SOLID principles:
 * - Single Responsibility: Only responsible for section layout and composition
 * - Open/Closed: Open for extension via props, closed for modification
 * - Dependency Inversion: Depends on component interfaces, not concrete implementations
 * - Interface Segregation: Uses focused interfaces for each sub-component
 */

import React from 'react';
import { spacing } from '@/design-system/utils';
import { SectionHeader } from '@/components/ui/section-header';
import { NavigationDifficultyList } from './NavigationDifficultyList';
import { NavigationDifficultySectionProps } from './types';

/**
 * Navigation Difficulty Section Component
 * Main section component that composes header and item list components
 */
export const NavigationDifficultySection: React.FC<
  NavigationDifficultySectionProps
> = ({ title = 'Navigation Difficulty', items, className }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: spacing[3],
      }}
      className={className}
    >
      <SectionHeader title={title} />

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: spacing[3],
          padding: `0 ${spacing[3]}px ${spacing[3]}px`,
        }}
      >
        <NavigationDifficultyList items={items} />
      </div>
    </div>
  );
};
